import _regeneratorRuntime from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/inherits";
import React from 'react';
import ruLocale from 'date-fns/locale/ru';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { CssBaseline } from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { ToastContainer } from 'react-toastify';
import DateFnsUtils from '@date-io/date-fns';
import Loadable from 'react-loadable';
import get from 'lodash/get';
import Loader from '../loader/Loader';
import { importModule } from '../../utils/import';
import themeWhite from '../../theme/white';
import themeBlack from '../../theme/black';
import themeBlue from '../../theme/blue';
var themes = {
  white: themeWhite,
  black: themeBlack,
  blue: themeBlue
};
export function withCore(WrappedComponent, routes, changeRoutes) {
  return (
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(_class, _React$Component);

      function _class(props) {
        var _this;

        _classCallCheck(this, _class);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, props));
        _this.state = {
          name: 'white',
          theme: themes.white
        };
        /**
         * Переключение темы
         */

        _this.changeTheme = function () {
          var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'white';

          if (themes[name]) {
            _this.setState({
              name: name,
              theme: themes[name]
            });

            localStorage.setItem('theme', name);
          }
        };

        var storageTheme = localStorage.getItem('theme');

        if (storageTheme && themes[storageTheme]) {
          _this.state = {
            name: storageTheme,
            theme: themes[storageTheme]
          };
        }

        return _this;
      }

      _createClass(_class, [{
        key: "render",
        value: function render() {
          var theme = this.state.theme;
          return React.createElement(ThemeProvider, {
            theme: createMuiTheme(theme)
          }, React.createElement(CssBaseline, null), React.createElement(MuiPickersUtilsProvider, {
            utils: DateFnsUtils,
            locale: ruLocale
          }, React.createElement(ToastContainer, {
            autoClose: 5000,
            draggable: false
          }), React.createElement(WrappedComponent, Object.assign({}, this.props, {
            routes: getRoutes(routes, changeRoutes),
            changeTheme: this.changeTheme
          }))));
        }
      }]);

      return _class;
    }(React.Component)
  );
}

var loadModule =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(url) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return importModule(url);

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function loadModule(_x) {
    return _ref.apply(this, arguments);
  };
}();

var getModule = function getModule(componentName) {
  return get(window, componentName, null);
};

var getRoutes = function getRoutes(routes, changeRoutes) {
  return routes.map(function (route) {
    if (route.url && route.componentName) {
      var module = getModule(route.componentName);
      var ModuleComponent = module ? module.default : Loadable({
        loader: function () {
          var _loader = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee2() {
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 2;
                    return loadModule(route.url);

                  case 2:
                    return _context2.abrupt("return", getModule(route.componentName));

                  case 3:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));

          function loader() {
            return _loader.apply(this, arguments);
          }

          return loader;
        }(),
        loading: function loading() {
          return React.createElement(Loader, null);
        }
      });

      route.component = function (props) {
        return React.createElement(ModuleComponent, Object.assign({}, props, {
          loaded: !!module,
          changeRoutes: changeRoutes
        }));
      };
    }

    if (route.routes) {
      route.routes = getRoutes(route.routes, changeRoutes);
    }

    return route;
  });
};